import { render, staticRenderFns } from "./AssessmentsAnswer.vue?vue&type=template&id=d4e45d38"
import script from "./AssessmentsAnswer.vue?vue&type=script&lang=js"
export * from "./AssessmentsAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports